/* Panel order — 選択した10 × 10の穴位置を●○パターンとして保持・コピーする。 */
(function () {
  "use strict";

  var GRID_SIZE = 10;

  function PanelOrder(root) {
    var grid = root.querySelector("[data-panel-order-grid]");
    var count = root.querySelector("[data-panel-order-count]");
    var value = root.querySelector("[data-panel-order-value]");
    var toastElement = root.querySelector("[data-panel-order-toast]");
    var buttons = [];
    var toastTimer;

    if (!grid) return;

    function pattern() {
      var lines = [];
      for (var row = 0; row < GRID_SIZE; row += 1) {
        var line = "";
        for (var column = 0; column < GRID_SIZE; column += 1) {
          line += buttons[row * GRID_SIZE + column].getAttribute("aria-pressed") === "true" ? "●" : "○";
        }
        lines.push(line);
      }
      return lines.join("\n");
    }

    function update() {
      var selected = buttons.filter(function (button) {
        return button.getAttribute("aria-pressed") === "true";
      }).length;
      if (count) count.textContent = selected;
      if (value) value.value = pattern();
    }

    function setSelected(button, selected) {
      button.setAttribute("aria-pressed", selected ? "true" : "false");
    }

    function showToast(message) {
      if (!toastElement) return;
      toastElement.textContent = message;
      toastElement.classList.add("is-visible");
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toastElement.classList.remove("is-visible");
      }, 1600);
    }

    function fallbackCopy(text) {
      var textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      textarea.remove();
    }

    for (var index = 0; index < GRID_SIZE * GRID_SIZE; index += 1) {
      var button = document.createElement("button");
      var row = Math.floor(index / GRID_SIZE) + 1;
      var column = (index % GRID_SIZE) + 1;
      button.type = "button";
      button.className = "porder-hole";
      button.setAttribute("aria-label", row + "行 " + column + "列");
      button.setAttribute("aria-pressed", "false");
      grid.appendChild(button);
      buttons.push(button);
    }

    grid.addEventListener("click", function (event) {
      var button = event.target.closest(".porder-hole");
      if (!button || !grid.contains(button)) return;
      setSelected(button, button.getAttribute("aria-pressed") !== "true");
      update();
    });

    var copyButton = root.querySelector("[data-panel-order-copy]");
    if (copyButton) {
      copyButton.addEventListener("click", function () {
        var text = pattern();
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text).then(
            function () {
              showToast("パターンをコピーしました");
            },
            function () {
              fallbackCopy(text);
              showToast("パターンをコピーしました");
            },
          );
        } else {
          fallbackCopy(text);
          showToast("パターンをコピーしました");
        }
      });
    }

    var allButton = root.querySelector("[data-panel-order-all]");
    if (allButton) {
      allButton.addEventListener("click", function () {
        buttons.forEach(function (button) {
          setSelected(button, true);
        });
        update();
        showToast("すべて選択しました");
      });
    }

    var resetButton = root.querySelector("[data-panel-order-reset]");
    if (resetButton) {
      resetButton.addEventListener("click", function () {
        buttons.forEach(function (button) {
          setSelected(button, false);
        });
        update();
        showToast("リセットしました");
      });
    }

    update();
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll("[data-panel-order-root]"),
      PanelOrder,
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
